export const createMediaPlanSelector = state => state.createMediaPlan;
